import React, { useState } from "react";
import {
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ClickAwayListener,
  Popper,
} from "@mui/material";
// config
import colors from "../config/colors";

const CustomDropdownMenu = ({
  trigger,
  items = [],
  placement = "bottom-start",
  offset = [0, 8],
  itemGap = "8px",
  /** Fired when the menu opens (after user clicks trigger). */
  onMenuOpen,
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpen((prevOpen) => {
      const next = !prevOpen;
      if (next && typeof onMenuOpen === "function") onMenuOpen();
      return next;
    });
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleItemClick = (item) => {
    if (item.disabled) return;
    if (item.onClick) {
      item.onClick(item);
    }
    handleClose();
  };

  return (
    <>
      <Box sx={{ cursor: "pointer" }} onClick={handleToggle}>
        {trigger}
      </Box>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        style={{ zIndex: 1300 }}
        modifiers={[
          {
            name: "offset",
            options: {
              offset: offset,
            },
          },
        ]}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            elevation={0}
            sx={{
              display: "flex",
              width: "172px",
              padding: "12px 16px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: "8px",
              borderRadius: "4px",
              background: colors.white,
              boxShadow: "0 2px 4px 2px rgba(0, 0, 0, 0.25)",
            }}
          >
            <List
              sx={{
                width: "100%",
                padding: 0,
                gap: itemGap,
                display: "flex",
                flexDirection: "column",
              }}
            >
              {items.map((item, index) => (
                <ListItem
                  key={index}
                  sx={{
                    padding: 0,
                    cursor: item.disabled ? "default" : "pointer",
                    borderRadius: "4px",
                    minHeight: "auto",
                    opacity: item.disabled ? 0.4 : 1,
                  }}
                  onClick={() => handleItemClick(item)}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "100%",
                      padding: "4px 0",
                    }}
                  >
                    {item.icon && (
                      <ListItemIcon
                        sx={{
                          minWidth: "auto",
                          margin: 0,
                          "& .MuiSvgIcon-root": {
                            fontSize: "18px",
                            color: item.iconColor,
                          },
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                    )}
                    <ListItemText
                      primary={item.label}
                      sx={{
                        margin: 0,
                        "& .MuiListItemText-primary": {
                          fontSize: "14px",
                          fontWeight: 400,
                          color: item.textColor,
                          lineHeight: 1.4,
                        },
                      }}
                    />
                  </Box>
                </ListItem>
              ))}
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default CustomDropdownMenu;
